import {HiOutlineMail} from 'react-icons/hi'
import {FaWhatsapp} from 'react-icons/fa'


const data = [
  { id: 1, icon: <HiOutlineMail />, link: "mailto:bashiraremu474@gmail.com" },
  { id: 2, icon: <FaWhatsapp/>,link:'https://wa.me/+2349156533542'},
];
export default data;